@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.send_money.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.send_money.generated.resources/"

internal val Res.string.feature_send_money_account_number: StringResource by lazy {
      StringResource("string:feature_send_money_account_number", "feature_send_money_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 169, 69),
      ))
    }

internal val Res.string.feature_send_money_account_number_error: StringResource by lazy {
      StringResource("string:feature_send_money_account_number_error", "feature_send_money_account_number_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 67),
      ))
    }

internal val Res.string.feature_send_money_account_number_mismatch: StringResource by lazy {
      StringResource("string:feature_send_money_account_number_mismatch", "feature_send_money_account_number_mismatch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78, 90),
      ))
    }

internal val Res.string.feature_send_money_add_bank_account: StringResource by lazy {
      StringResource("string:feature_send_money_add_bank_account", "feature_send_money_add_bank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 312, 67),
      ))
    }

internal val Res.string.feature_send_money_add_bank_account_desc: StringResource by lazy {
      StringResource("string:feature_send_money_add_bank_account_desc", "feature_send_money_add_bank_account_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 239, 72),
      ))
    }

internal val Res.string.feature_send_money_add_note: StringResource by lazy {
      StringResource("string:feature_send_money_add_note", "feature_send_money_add_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 380, 47),
      ))
    }

internal val Res.string.feature_send_money_amount: StringResource by lazy {
      StringResource("string:feature_send_money_amount", "feature_send_money_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 616, 41),
      ))
    }

internal val Res.string.feature_send_money_amount_below_minimum: StringResource by lazy {
      StringResource("string:feature_send_money_amount_below_minimum", "feature_send_money_amount_below_minimum", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 428, 87),
      ))
    }

internal val Res.string.feature_send_money_amount_exceeds_limit: StringResource by lazy {
      StringResource("string:feature_send_money_amount_exceeds_limit", "feature_send_money_amount_exceeds_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 516, 99),
      ))
    }

internal val Res.string.feature_send_money_autopay: StringResource by lazy {
      StringResource("string:feature_send_money_autopay", "feature_send_money_autopay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 658, 46),
      ))
    }

internal val Res.string.feature_send_money_balance: StringResource by lazy {
      StringResource("string:feature_send_money_balance", "feature_send_money_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 705, 46),
      ))
    }

internal val Res.string.feature_send_money_bank_branch: StringResource by lazy {
      StringResource("string:feature_send_money_bank_branch", "feature_send_money_bank_branch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 752, 54),
      ))
    }

internal val Res.string.feature_send_money_bank_details_note: StringResource by lazy {
      StringResource("string:feature_send_money_bank_details_note", "feature_send_money_bank_details_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 807, 176),
      ))
    }

internal val Res.string.feature_send_money_bank_icon: StringResource by lazy {
      StringResource("string:feature_send_money_bank_icon", "feature_send_money_bank_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 984, 48),
      ))
    }

internal val Res.string.feature_send_money_bank_name: StringResource by lazy {
      StringResource("string:feature_send_money_bank_name", "feature_send_money_bank_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1033, 48),
      ))
    }

internal val Res.string.feature_send_money_bank_transfer: StringResource by lazy {
      StringResource("string:feature_send_money_bank_transfer", "feature_send_money_bank_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1206, 60),
      ))
    }

internal val Res.string.feature_send_money_bank_transfer_to_others: StringResource by lazy {
      StringResource("string:feature_send_money_bank_transfer_to_others", "feature_send_money_bank_transfer_to_others", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1082, 62),
      ))
    }

internal val Res.string.feature_send_money_bank_transfer_to_self: StringResource by lazy {
      StringResource("string:feature_send_money_bank_transfer_to_self", "feature_send_money_bank_transfer_to_self", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1145, 60),
      ))
    }

internal val Res.string.feature_send_money_banking_name: StringResource by lazy {
      StringResource("string:feature_send_money_banking_name", "feature_send_money_banking_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1267, 63),
      ))
    }

internal val Res.string.feature_send_money_bottom_bar: StringResource by lazy {
      StringResource("string:feature_send_money_bottom_bar", "feature_send_money_bottom_bar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1331, 53),
      ))
    }

internal val Res.string.feature_send_money_cancel: StringResource by lazy {
      StringResource("string:feature_send_money_cancel", "feature_send_money_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1385, 41),
      ))
    }

internal val Res.string.feature_send_money_change_account: StringResource by lazy {
      StringResource("string:feature_send_money_change_account", "feature_send_money_change_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1427, 61),
      ))
    }

internal val Res.string.feature_send_money_check_now: StringResource by lazy {
      StringResource("string:feature_send_money_check_now", "feature_send_money_check_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1489, 48),
      ))
    }

internal val Res.string.feature_send_money_choose_account: StringResource by lazy {
      StringResource("string:feature_send_money_choose_account", "feature_send_money_choose_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1538, 77),
      ))
    }

internal val Res.string.feature_send_money_choose_method: StringResource by lazy {
      StringResource("string:feature_send_money_choose_method", "feature_send_money_choose_method", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1616, 84),
      ))
    }

internal val Res.string.feature_send_money_close: StringResource by lazy {
      StringResource("string:feature_send_money_close", "feature_send_money_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1701, 40),
      ))
    }

internal val Res.string.feature_send_money_confirm: StringResource by lazy {
      StringResource("string:feature_send_money_confirm", "feature_send_money_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1742, 46),
      ))
    }

internal val Res.string.feature_send_money_continue: StringResource by lazy {
      StringResource("string:feature_send_money_continue", "feature_send_money_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1789, 47),
      ))
    }

internal val Res.string.feature_send_money_done: StringResource by lazy {
      StringResource("string:feature_send_money_done", "feature_send_money_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1837, 39),
      ))
    }

internal val Res.string.feature_send_money_error_account_cannot_be_empty: StringResource by lazy {
      StringResource("string:feature_send_money_error_account_cannot_be_empty", "feature_send_money_error_account_cannot_be_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1877, 88),
      ))
    }

internal val Res.string.feature_send_money_error_amount_cannot_be_empty: StringResource by lazy {
      StringResource("string:feature_send_money_error_amount_cannot_be_empty", "feature_send_money_error_amount_cannot_be_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1966, 87),
      ))
    }

internal val Res.string.feature_send_money_error_fetching_balance: StringResource by lazy {
      StringResource("string:feature_send_money_error_fetching_balance", "feature_send_money_error_fetching_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 81),
      ))
    }

internal val Res.string.feature_send_money_error_invalid_amount: StringResource by lazy {
      StringResource("string:feature_send_money_error_invalid_amount", "feature_send_money_error_invalid_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2136, 67),
      ))
    }

internal val Res.string.feature_send_money_error_requesting_payment_qr_but_found: StringResource by
    lazy {
      StringResource("string:feature_send_money_error_requesting_payment_qr_but_found", "feature_send_money_error_requesting_payment_qr_but_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2204, 116),
      ))
    }

internal val Res.string.feature_send_money_error_requesting_payment_qr_data_missing: StringResource
    by lazy {
      StringResource("string:feature_send_money_error_requesting_payment_qr_data_missing", "feature_send_money_error_requesting_payment_qr_data_missing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2321, 139),
      ))
    }

internal val Res.string.feature_send_money_external_upi_payment: StringResource by lazy {
      StringResource("string:feature_send_money_external_upi_payment", "feature_send_money_external_upi_payment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2461, 75),
      ))
    }

internal val Res.string.feature_send_money_fineract_payments: StringResource by lazy {
      StringResource("string:feature_send_money_fineract_payments", "feature_send_money_fineract_payments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2537, 68),
      ))
    }

internal val Res.string.feature_send_money_ifsc_code: StringResource by lazy {
      StringResource("string:feature_send_money_ifsc_code", "feature_send_money_ifsc_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2606, 48),
      ))
    }

internal val Res.string.feature_send_money_ifsc_validation_error: StringResource by lazy {
      StringResource("string:feature_send_money_ifsc_validation_error", "feature_send_money_ifsc_validation_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2655, 124),
      ))
    }

internal val Res.string.feature_send_money_insufficient_balance: StringResource by lazy {
      StringResource("string:feature_send_money_insufficient_balance", "feature_send_money_insufficient_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2780, 75),
      ))
    }

internal val Res.string.feature_send_money_loading: StringResource by lazy {
      StringResource("string:feature_send_money_loading", "feature_send_money_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2856, 46),
      ))
    }

internal val Res.string.feature_send_money_merchants: StringResource by lazy {
      StringResource("string:feature_send_money_merchants", "feature_send_money_merchants", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2903, 48),
      ))
    }

internal val Res.string.feature_send_money_mobile: StringResource by lazy {
      StringResource("string:feature_send_money_mobile", "feature_send_money_mobile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2952, 53),
      ))
    }

internal val Res.string.feature_send_money_more: StringResource by lazy {
      StringResource("string:feature_send_money_more", "feature_send_money_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3006, 39),
      ))
    }

internal val Res.string.feature_send_money_no_accounts_found: StringResource by lazy {
      StringResource("string:feature_send_money_no_accounts_found", "feature_send_money_no_accounts_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3046, 68),
      ))
    }

internal val Res.string.feature_send_money_no_ifsc_found: StringResource by lazy {
      StringResource("string:feature_send_money_no_ifsc_found", "feature_send_money_no_ifsc_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3115, 68),
      ))
    }

internal val Res.string.feature_send_money_not_allowed: StringResource by lazy {
      StringResource("string:feature_send_money_not_allowed", "feature_send_money_not_allowed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3184, 86),
      ))
    }

internal val Res.string.feature_send_money_oops: StringResource by lazy {
      StringResource("string:feature_send_money_oops", "feature_send_money_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3271, 39),
      ))
    }

internal val Res.string.feature_send_money_paid_to: StringResource by lazy {
      StringResource("string:feature_send_money_paid_to", "feature_send_money_paid_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3311, 46),
      ))
    }

internal val Res.string.feature_send_money_pay_amount: StringResource by lazy {
      StringResource("string:feature_send_money_pay_amount", "feature_send_money_pay_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3358, 49),
      ))
    }

internal val Res.string.feature_send_money_pay_anyone: StringResource by lazy {
      StringResource("string:feature_send_money_pay_anyone", "feature_send_money_pay_anyone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3408, 53),
      ))
    }

internal val Res.string.feature_send_money_payee_details_title: StringResource by lazy {
      StringResource("string:feature_send_money_payee_details_title", "feature_send_money_payee_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3462, 66),
      ))
    }

internal val Res.string.feature_send_money_payee_profile: StringResource by lazy {
      StringResource("string:feature_send_money_payee_profile", "feature_send_money_payee_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3529, 60),
      ))
    }

internal val Res.string.feature_send_money_paying: StringResource by lazy {
      StringResource("string:feature_send_money_paying", "feature_send_money_paying", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3665, 49),
      ))
    }

internal val Res.string.feature_send_money_paying_securely: StringResource by lazy {
      StringResource("string:feature_send_money_paying_securely", "feature_send_money_paying_securely", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3590, 74),
      ))
    }

internal val Res.string.feature_send_money_payment_success: StringResource by lazy {
      StringResource("string:feature_send_money_payment_success", "feature_send_money_payment_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3810, 66),
      ))
    }

internal val Res.string.feature_send_money_payment_success_description: StringResource by lazy {
      StringResource("string:feature_send_money_payment_success_description", "feature_send_money_payment_success_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3715, 94),
      ))
    }

internal val Res.string.feature_send_money_people: StringResource by lazy {
      StringResource("string:feature_send_money_people", "feature_send_money_people", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3877, 41),
      ))
    }

internal val Res.string.feature_send_money_phone_number: StringResource by lazy {
      StringResource("string:feature_send_money_phone_number", "feature_send_money_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3919, 55),
      ))
    }

internal val Res.string.feature_send_money_please_wait: StringResource by lazy {
      StringResource("string:feature_send_money_please_wait", "feature_send_money_please_wait", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3975, 58),
      ))
    }

internal val Res.string.feature_send_money_powered_by_upi: StringResource by lazy {
      StringResource("string:feature_send_money_powered_by_upi", "feature_send_money_powered_by_upi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4034, 61),
      ))
    }

internal val Res.string.feature_send_money_proceed: StringResource by lazy {
      StringResource("string:feature_send_money_proceed", "feature_send_money_proceed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4096, 46),
      ))
    }

internal val Res.string.feature_send_money_receivers_bank_details: StringResource by lazy {
      StringResource("string:feature_send_money_receivers_bank_details", "feature_send_money_receivers_bank_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4143, 81),
      ))
    }

internal val Res.string.feature_send_money_receivers_name: StringResource by lazy {
      StringResource("string:feature_send_money_receivers_name", "feature_send_money_receivers_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4312, 61),
      ))
    }

internal val Res.string.feature_send_money_receivers_name_required: StringResource by lazy {
      StringResource("string:feature_send_money_receivers_name_required", "feature_send_money_receivers_name_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4225, 86),
      ))
    }

internal val Res.string.feature_send_money_recent_transfers: StringResource by lazy {
      StringResource("string:feature_send_money_recent_transfers", "feature_send_money_recent_transfers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4374, 67),
      ))
    }

internal val Res.string.feature_send_money_reenter_account_number: StringResource by lazy {
      StringResource("string:feature_send_money_reenter_account_number", "feature_send_money_reenter_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4442, 89),
      ))
    }

internal val Res.string.feature_send_money_rupee_icon: StringResource by lazy {
      StringResource("string:feature_send_money_rupee_icon", "feature_send_money_rupee_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4532, 53),
      ))
    }

internal val Res.string.feature_send_money_scan_qr: StringResource by lazy {
      StringResource("string:feature_send_money_scan_qr", "feature_send_money_scan_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4650, 46),
      ))
    }

internal val Res.string.feature_send_money_scan_qr_code: StringResource by lazy {
      StringResource("string:feature_send_money_scan_qr_code", "feature_send_money_scan_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4586, 63),
      ))
    }

internal val Res.string.feature_send_money_search_ifsc: StringResource by lazy {
      StringResource("string:feature_send_money_search_ifsc", "feature_send_money_search_ifsc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4896, 58),
      ))
    }

internal val Res.string.feature_send_money_search_ifsc_instructions: StringResource by lazy {
      StringResource("string:feature_send_money_search_ifsc_instructions", "feature_send_money_search_ifsc_instructions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4697, 107),
      ))
    }

internal val Res.string.feature_send_money_search_ifsc_placeholder: StringResource by lazy {
      StringResource("string:feature_send_money_search_ifsc_placeholder", "feature_send_money_search_ifsc_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4805, 90),
      ))
    }

internal val Res.string.feature_send_money_searching: StringResource by lazy {
      StringResource("string:feature_send_money_searching", "feature_send_money_searching", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4955, 52),
      ))
    }

internal val Res.string.feature_send_money_select_different_accounts: StringResource by lazy {
      StringResource("string:feature_send_money_select_different_accounts", "feature_send_money_select_different_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5008, 112),
      ))
    }

internal val Res.string.feature_send_money_select_transfer_method: StringResource by lazy {
      StringResource("string:feature_send_money_select_transfer_method", "feature_send_money_select_transfer_method", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5121, 81),
      ))
    }

internal val Res.string.feature_send_money_selected: StringResource by lazy {
      StringResource("string:feature_send_money_selected", "feature_send_money_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5203, 47),
      ))
    }

internal val Res.string.feature_send_money_self_transfer: StringResource by lazy {
      StringResource("string:feature_send_money_self_transfer", "feature_send_money_self_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5251, 60),
      ))
    }

internal val Res.string.feature_send_money_send: StringResource by lazy {
      StringResource("string:feature_send_money_send", "feature_send_money_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5312, 47),
      ))
    }

internal val Res.string.feature_send_money_share_screenshot: StringResource by lazy {
      StringResource("string:feature_send_money_share_screenshot", "feature_send_money_share_screenshot", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5360, 67),
      ))
    }

internal val Res.string.feature_send_money_something_went_wrong: StringResource by lazy {
      StringResource("string:feature_send_money_something_went_wrong", "feature_send_money_something_went_wrong", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5428, 75),
      ))
    }

internal val Res.string.feature_send_money_submit: StringResource by lazy {
      StringResource("string:feature_send_money_submit", "feature_send_money_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5504, 41),
      ))
    }

internal val Res.string.feature_send_money_title: StringResource by lazy {
      StringResource("string:feature_send_money_title", "feature_send_money_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5546, 64),
      ))
    }

internal val Res.string.feature_send_money_to_account: StringResource by lazy {
      StringResource("string:feature_send_money_to_account", "feature_send_money_to_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5611, 53),
      ))
    }

internal val Res.string.feature_send_money_upi_id: StringResource by lazy {
      StringResource("string:feature_send_money_upi_id", "feature_send_money_upi_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5665, 49),
      ))
    }

internal val Res.string.feature_send_money_upi_qr_parsed_successfully: StringResource by lazy {
      StringResource("string:feature_send_money_upi_qr_parsed_successfully", "feature_send_money_upi_qr_parsed_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5715, 97),
      ))
    }

internal val Res.string.feature_send_money_virtual_payment_address: StringResource by lazy {
      StringResource("string:feature_send_money_virtual_payment_address", "feature_send_money_virtual_payment_address", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5813, 82),
      ))
    }

internal val Res.string.feature_send_money_vpa: StringResource by lazy {
      StringResource("string:feature_send_money_vpa", "feature_send_money_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5985, 34),
      ))
    }

internal val Res.string.feature_send_money_vpa_mobile_account_number: StringResource by lazy {
      StringResource("string:feature_send_money_vpa_mobile_account_number", "feature_send_money_vpa_mobile_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5896, 88),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_send_money_account_number", Res.string.feature_send_money_account_number)
  map.put("feature_send_money_account_number_error", Res.string.feature_send_money_account_number_error)
  map.put("feature_send_money_account_number_mismatch", Res.string.feature_send_money_account_number_mismatch)
  map.put("feature_send_money_add_bank_account", Res.string.feature_send_money_add_bank_account)
  map.put("feature_send_money_add_bank_account_desc", Res.string.feature_send_money_add_bank_account_desc)
  map.put("feature_send_money_add_note", Res.string.feature_send_money_add_note)
  map.put("feature_send_money_amount", Res.string.feature_send_money_amount)
  map.put("feature_send_money_amount_below_minimum", Res.string.feature_send_money_amount_below_minimum)
  map.put("feature_send_money_amount_exceeds_limit", Res.string.feature_send_money_amount_exceeds_limit)
  map.put("feature_send_money_autopay", Res.string.feature_send_money_autopay)
  map.put("feature_send_money_balance", Res.string.feature_send_money_balance)
  map.put("feature_send_money_bank_branch", Res.string.feature_send_money_bank_branch)
  map.put("feature_send_money_bank_details_note", Res.string.feature_send_money_bank_details_note)
  map.put("feature_send_money_bank_icon", Res.string.feature_send_money_bank_icon)
  map.put("feature_send_money_bank_name", Res.string.feature_send_money_bank_name)
  map.put("feature_send_money_bank_transfer", Res.string.feature_send_money_bank_transfer)
  map.put("feature_send_money_bank_transfer_to_others", Res.string.feature_send_money_bank_transfer_to_others)
  map.put("feature_send_money_bank_transfer_to_self", Res.string.feature_send_money_bank_transfer_to_self)
  map.put("feature_send_money_banking_name", Res.string.feature_send_money_banking_name)
  map.put("feature_send_money_bottom_bar", Res.string.feature_send_money_bottom_bar)
  map.put("feature_send_money_cancel", Res.string.feature_send_money_cancel)
  map.put("feature_send_money_change_account", Res.string.feature_send_money_change_account)
  map.put("feature_send_money_check_now", Res.string.feature_send_money_check_now)
  map.put("feature_send_money_choose_account", Res.string.feature_send_money_choose_account)
  map.put("feature_send_money_choose_method", Res.string.feature_send_money_choose_method)
  map.put("feature_send_money_close", Res.string.feature_send_money_close)
  map.put("feature_send_money_confirm", Res.string.feature_send_money_confirm)
  map.put("feature_send_money_continue", Res.string.feature_send_money_continue)
  map.put("feature_send_money_done", Res.string.feature_send_money_done)
  map.put("feature_send_money_error_account_cannot_be_empty", Res.string.feature_send_money_error_account_cannot_be_empty)
  map.put("feature_send_money_error_amount_cannot_be_empty", Res.string.feature_send_money_error_amount_cannot_be_empty)
  map.put("feature_send_money_error_fetching_balance", Res.string.feature_send_money_error_fetching_balance)
  map.put("feature_send_money_error_invalid_amount", Res.string.feature_send_money_error_invalid_amount)
  map.put("feature_send_money_error_requesting_payment_qr_but_found", Res.string.feature_send_money_error_requesting_payment_qr_but_found)
  map.put("feature_send_money_error_requesting_payment_qr_data_missing", Res.string.feature_send_money_error_requesting_payment_qr_data_missing)
  map.put("feature_send_money_external_upi_payment", Res.string.feature_send_money_external_upi_payment)
  map.put("feature_send_money_fineract_payments", Res.string.feature_send_money_fineract_payments)
  map.put("feature_send_money_ifsc_code", Res.string.feature_send_money_ifsc_code)
  map.put("feature_send_money_ifsc_validation_error", Res.string.feature_send_money_ifsc_validation_error)
  map.put("feature_send_money_insufficient_balance", Res.string.feature_send_money_insufficient_balance)
  map.put("feature_send_money_loading", Res.string.feature_send_money_loading)
  map.put("feature_send_money_merchants", Res.string.feature_send_money_merchants)
  map.put("feature_send_money_mobile", Res.string.feature_send_money_mobile)
  map.put("feature_send_money_more", Res.string.feature_send_money_more)
  map.put("feature_send_money_no_accounts_found", Res.string.feature_send_money_no_accounts_found)
  map.put("feature_send_money_no_ifsc_found", Res.string.feature_send_money_no_ifsc_found)
  map.put("feature_send_money_not_allowed", Res.string.feature_send_money_not_allowed)
  map.put("feature_send_money_oops", Res.string.feature_send_money_oops)
  map.put("feature_send_money_paid_to", Res.string.feature_send_money_paid_to)
  map.put("feature_send_money_pay_amount", Res.string.feature_send_money_pay_amount)
  map.put("feature_send_money_pay_anyone", Res.string.feature_send_money_pay_anyone)
  map.put("feature_send_money_payee_details_title", Res.string.feature_send_money_payee_details_title)
  map.put("feature_send_money_payee_profile", Res.string.feature_send_money_payee_profile)
  map.put("feature_send_money_paying", Res.string.feature_send_money_paying)
  map.put("feature_send_money_paying_securely", Res.string.feature_send_money_paying_securely)
  map.put("feature_send_money_payment_success", Res.string.feature_send_money_payment_success)
  map.put("feature_send_money_payment_success_description", Res.string.feature_send_money_payment_success_description)
  map.put("feature_send_money_people", Res.string.feature_send_money_people)
  map.put("feature_send_money_phone_number", Res.string.feature_send_money_phone_number)
  map.put("feature_send_money_please_wait", Res.string.feature_send_money_please_wait)
  map.put("feature_send_money_powered_by_upi", Res.string.feature_send_money_powered_by_upi)
  map.put("feature_send_money_proceed", Res.string.feature_send_money_proceed)
  map.put("feature_send_money_receivers_bank_details", Res.string.feature_send_money_receivers_bank_details)
  map.put("feature_send_money_receivers_name", Res.string.feature_send_money_receivers_name)
  map.put("feature_send_money_receivers_name_required", Res.string.feature_send_money_receivers_name_required)
  map.put("feature_send_money_recent_transfers", Res.string.feature_send_money_recent_transfers)
  map.put("feature_send_money_reenter_account_number", Res.string.feature_send_money_reenter_account_number)
  map.put("feature_send_money_rupee_icon", Res.string.feature_send_money_rupee_icon)
  map.put("feature_send_money_scan_qr", Res.string.feature_send_money_scan_qr)
  map.put("feature_send_money_scan_qr_code", Res.string.feature_send_money_scan_qr_code)
  map.put("feature_send_money_search_ifsc", Res.string.feature_send_money_search_ifsc)
  map.put("feature_send_money_search_ifsc_instructions", Res.string.feature_send_money_search_ifsc_instructions)
  map.put("feature_send_money_search_ifsc_placeholder", Res.string.feature_send_money_search_ifsc_placeholder)
  map.put("feature_send_money_searching", Res.string.feature_send_money_searching)
  map.put("feature_send_money_select_different_accounts", Res.string.feature_send_money_select_different_accounts)
  map.put("feature_send_money_select_transfer_method", Res.string.feature_send_money_select_transfer_method)
  map.put("feature_send_money_selected", Res.string.feature_send_money_selected)
  map.put("feature_send_money_self_transfer", Res.string.feature_send_money_self_transfer)
  map.put("feature_send_money_send", Res.string.feature_send_money_send)
  map.put("feature_send_money_share_screenshot", Res.string.feature_send_money_share_screenshot)
  map.put("feature_send_money_something_went_wrong", Res.string.feature_send_money_something_went_wrong)
  map.put("feature_send_money_submit", Res.string.feature_send_money_submit)
  map.put("feature_send_money_title", Res.string.feature_send_money_title)
  map.put("feature_send_money_to_account", Res.string.feature_send_money_to_account)
  map.put("feature_send_money_upi_id", Res.string.feature_send_money_upi_id)
  map.put("feature_send_money_upi_qr_parsed_successfully", Res.string.feature_send_money_upi_qr_parsed_successfully)
  map.put("feature_send_money_virtual_payment_address", Res.string.feature_send_money_virtual_payment_address)
  map.put("feature_send_money_vpa", Res.string.feature_send_money_vpa)
  map.put("feature_send_money_vpa_mobile_account_number", Res.string.feature_send_money_vpa_mobile_account_number)
}
